import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { RestserviceService } from '../services/restservice.service';
import { UserAuthService } from './user-auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private service: RestserviceService,
    private userAuth: UserAuthService,
    private router: Router,
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const token = this.userAuth.getToken();
    if (token) {
      req = req.clone({
        setHeaders: {
          Authorization: token.startsWith('Bearer') ? token : `Bearer ${token}`,
        },
      });
    }
    // this.service.show();

    return next.handle(req).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 401) {
          // ✅ hard reset on session expiry
          this.userAuth.logout();

          // avoid navigation loop (guard already prevents redirecting to self)
          if (this.router.url !== '/login') {
            this.router.navigate(['/login']);
          }
        }

        return throwError(() => err); // ⚠️ rethrow ORIGINAL error
      }),

      // ✅ ALWAYS executes (fixes infinite loader)
      finalize(() => {
        // if you have LoaderService → hide here
        //  console.log('LOADER HIDE');
        this.service.hide();
      }),
    );
  }
}
